// src/utils/security.js
export class SecurityUtil {
  constructor(config = {}) {
    this.config = config;
    this.ipLookupUrl = config.ipLookupUrl || 'https://ipapi.co/json/';
    this.proxyIndicators = config.proxyIndicators || ['VPN', 'proxy', 'hosting', 'cdn', 'google', 'amazon', 'microsoft'];
    this.timeout = config.timeout || 8000;
  }

  // Performs a light-weight analysis returning indicators and a riskScore (0-100)
  async analyzeConnection() {
    const indicators = [];
    let riskScore = 0;

    // connection info heuristics
    try {
      // fetch IP and org data
      const res = await fetch(this.ipLookupUrl, { cache: 'no-store' });
      if (res.ok) {
        const info = await res.json();
        const org = (info.org || info.isp || '').toLowerCase();

        // basic heuristics: check if org contains known hosting providers or "proxy"
        for (const term of this.proxyIndicators) {
          if (org.includes(term.toLowerCase())) {
            indicators.push({ type: 'suspicious_org', value: org, matched: term });
            riskScore += 30;
          }
        }

        // suspicious if IP is missing a city/country
        if (!info.country || !info.city) {
          indicators.push({ type: 'geo_sparse', raw: info });
          riskScore += 15;
        }

        // add ip/country to indicators
        indicators.push({ type: 'ip_info', raw: info });
      } else {
        indicators.push({ type: 'ip_lookup_failed', status: res.status });
      }
    } catch (err) {
      indicators.push({ type: 'ip_lookup_error', error: err.message });
    }

    // Check navigator.connection if available
    try {
      if (navigator && navigator.connection) {
        const conn = navigator.connection;
        indicators.push({ type: 'connection', effectiveType: conn.effectiveType, downlink: conn.downlink });
        if (conn.effectiveType === '2g' || conn.effectiveType === 'slow-2g') riskScore += 5;
      }
    } catch (e) {
      // ignore
    }

    // Check if browser has unusual capabilities (too few cores -> can be headless)
    try {
      const cores = navigator.hardwareConcurrency || 0;
      if (cores === 1) {
        indicators.push({ type: 'low_cpu_count', cores });
        riskScore += 5;
      }
    } catch (e) {}

    // Clamp risk to 0-100
    riskScore = Math.min(100, Math.max(0, riskScore));

    return {
      riskScore,
      indicators
    };
  }
}
